import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, type = "text", ...rest }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        className={cn(
          "flex h-11 w-full rounded-[var(--radius-md)] px-4 text-sm transition-all",
          "glass placeholder:text-[var(--color-fg-tertiary)]",
          "focus:outline-none focus:border-[var(--color-brand-purple)] focus:ring-2 focus:ring-[var(--color-brand-purple-soft)]",
          "disabled:cursor-not-allowed disabled:opacity-50",
          invalid &&
            "border-[var(--color-danger)] focus:border-[var(--color-danger)] focus:ring-[var(--color-danger-soft)]",
          className,
        )}
        {...rest}
      />
    );
  },
);
Input.displayName = "Input";
